<div class="auto-complete">
    <input
        data-cy="cy-autocomplete-input-drug"
        placeholder="Lookup drug by name"
        nz-input
        class="drug-input"
        (input)="onChange($event)"
        [(ngModel)]="keyword"
        [nzAutocomplete]="auto"
    />
    <nz-autocomplete #auto>
        <nz-auto-option
            [attr.data-cy]="'cy-option-drug-' + drug.din"
            *ngFor="let drug of filteredDrugs"
            [nzValue]="drug.name"
            (selectionChange)="fieldSelected($event, drug)"
        >
            <div class="global-search-item">
                <i nz-icon nzType="code-sandbox" nzTheme="outline"></i>
                <div class="flex flex-col gap-1">
                    <div class="font-medium text-gray-900">{{ drug.name }}</div>
                    <div class="flex flex-wrap gap-2 text-sm text-gray-600">
                        <nz-tag *ngIf="drug.din"
                            ><small class="text-gray-500">DIN:</small>
                            {{ drug.din }}</nz-tag
                        >
                        <nz-tag *ngIf="drug.mitte"
                            ><small class="text-gray-500">Mitte:</small>
                            {{ drug.mitte }}</nz-tag
                        >
                        <nz-tag *ngIf="drug.refills"
                            ><small class="text-gray-500">Refills:</small>
                            {{ drug.refills }}</nz-tag
                        >
                    </div>
                </div>
            </div>
        </nz-auto-option>
    </nz-autocomplete>
    <button
        data-cy="cy-button-add-drug"
        *ngIf="addButton"
        nz-button
        nzType="primary"
        (click)="onAddDrugClick()"
        class="drug-add-button"
        nzSize="large"
    >
        Add Drug
    </button>
</div>
